import { Map, List } from 'immutable';
import { actions } from './actions';
import * as lib from './lib';

const initialState = new Map({
  valid: false,
  passcode: '',
  activities: new List(),
  schedules: new Map({
    current: new Map(),
    next: new Map(),
  }),
  userLevels: new List(),
});

const validInitialState = initialState.set('valid', true);

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.SET:
      return validInitialState.merge(value); // value contains a user
    case actions.CLEAR:
      return initialState.set('passcode', ''.padEnd(state.get('passcode').length));
    case actions.SET_ACTIVITY:
      return state.set('activities', new List([value]));
    case actions.FORWARD_ACTIVITY:
      return state.update('activities', activities => activities.unshift(value));
    case actions.BACKWARD_ACTIVITY:
      return state.update('activities', activities => activities.shift());
    case actions.SET_SCHEDULES:
      return lib.setSchedules(state, value);
    case actions.SET_PASSCODE:
      return state.set('passcode', value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/currentUser/reducer.js